import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bce0a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { PropType, ref } from "vue";
import { MarkdownEditorComposable } from "./markdown-editor";
import InsertDialog from "./components/InsertDialog.vue";
import AttributeDialog from "./components/AttributeDialog.vue";
import Toolbar from "./components/Toolbar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkdownEditor',
  props: {
  modelValue: {
    type: String as PropType<string>,
    default: ""
  },
  uploadPath: {
    type: String,
    default: ""
  }
},
  emits: ["update:modelValue", "input"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const editor = ref<HTMLElement>();
const currentElement = ref<HTMLElement>();

const {
  showInsertDialog,
  showAttributeDialog,
  onChange,
  onKeydown,
  confirmAttributes,
  cancelInsert,
  removeElement,
  editElementAttributes,
  handlePaste,
  handleImage,
  handleQuote,
  handleCode,
  handleInlineCode,
  handleOrderedList,
  handleUnorderedList,
  updateSelection,
  uploadPath
} = MarkdownEditorComposable(props, emit, editor, currentElement);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "editor-label",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showInsertDialog.value = !_unref(showInsertDialog)))
    }, "Markdown"),
    _createElementVNode("div", {
      ref_key: "editor",
      ref: editor,
      class: "editor",
      contenteditable: "true",
      onPaste: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handlePaste) && _unref(handlePaste)(...args))),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(updateSelection) && _unref(updateSelection)(...args))),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onChange) && _unref(onChange)(...args))),
      onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onKeydown) && _unref(onKeydown)(...args)))
    }, _hoisted_3, 544),
    _createVNode(Toolbar, {
      currentElement: currentElement.value,
      onEdit: _unref(editElementAttributes),
      onRemove: _unref(removeElement),
      onInsertImage: _unref(handleImage),
      onInsertQuote: _unref(handleQuote),
      onInsertCode: _unref(handleCode),
      onInsertInlineCode: _unref(handleInlineCode),
      onInsertOrderedList: _unref(handleOrderedList),
      onInsertUnorderedList: _unref(handleUnorderedList)
    }, null, 8, ["currentElement", "onEdit", "onRemove", "onInsertImage", "onInsertQuote", "onInsertCode", "onInsertInlineCode", "onInsertOrderedList", "onInsertUnorderedList"]),
    _createVNode(InsertDialog, {
      show: _unref(showInsertDialog),
      onClose: _cache[5] || (_cache[5] = ($event: any) => (showInsertDialog.value = false))
    }, null, 8, ["show"]),
    (currentElement.value && _unref(showAttributeDialog))
      ? (_openBlock(), _createBlock(AttributeDialog, {
          key: 0,
          currentElement: currentElement.value,
          show: _unref(showAttributeDialog),
          uploadPath: _unref(uploadPath),
          onConfirm: _unref(confirmAttributes),
          onCancel: _unref(cancelInsert)
        }, null, 8, ["currentElement", "show", "uploadPath", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})